import React from 'react';
import { AnchorIcon, TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { ports } from '../data/operations';
export function PortCongestion() {
  return <section className="border border-slate-700/80 bg-[#09131c]" aria-labelledby="ports-heading" data-id="element-88">
      <div className="flex items-center gap-2 border-b border-slate-700/70 px-3 py-2.5" data-id="element-89">
        <AnchorIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-90" />
        <div data-id="element-91">
          <h2 id="ports-heading" className="font-display text-xs font-bold tracking-[0.14em] text-slate-100" data-id="element-92">
            PORT CONGESTION
          </h2>
          <p className="font-mono text-[8px] text-slate-500" data-id="element-93">
            BERTH UTILIZATION / 24H
          </p>
        </div>
      </div>
      <div className="divide-y divide-slate-800" data-id="element-94">
        {ports.map(port => {
        const critical = port.utilization >= 90;
        const warning = port.utilization >= 80;
        return <div key={port.code} className="px-3 py-2.5" data-id="element-95">
              <div className="mb-1.5 flex items-center justify-between" data-id="element-96">
                <div className="flex items-baseline gap-2" data-id="element-97">
                  <span className="font-mono text-[10px] font-bold text-slate-200" data-id="element-98">
                    {port.code}
                  </span>
                  <span className="text-[10px] text-slate-500" data-id="element-99">
                    {port.name}
                  </span>
                </div>
                <div className="flex items-center gap-2 font-mono text-[9px]" data-id="element-100">
                  <span className="text-slate-500" data-id="element-101">WAIT {port.wait}</span>
                  <span className={port.trend.startsWith('+') ? 'text-red-300' : 'text-lime-300'} data-id="element-102">
                    {port.trend.startsWith('+') ? <TrendingUpIcon className="mr-0.5 inline h-3 w-3" data-id="element-103" /> : <TrendingDownIcon className="mr-0.5 inline h-3 w-3" data-id="element-104" />}
                    {port.trend}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-105">
                <div className="h-1 flex-1 bg-slate-800" role="progressbar" aria-label={`${port.name} berth utilization`} aria-valuenow={port.utilization} aria-valuemin={0} aria-valuemax={100} data-id="element-106">
                  <div className={`h-full ${critical ? 'bg-red-400' : warning ? 'bg-amber-400' : 'bg-cyan-400'}`} style={{
                width: `${port.utilization}%`
              }} data-id="element-107" />
                </div>
                <span className={`w-8 text-right font-mono text-[9px] ${critical ? 'text-red-300' : warning ? 'text-amber-300' : 'text-cyan-300'}`} data-id="element-108">
                  {port.utilization}%
                </span>
              </div>
            </div>;
      })}
      </div>
    </section>;
}